import {ref, Ref} from '@vue/composition-api';

export class EditorCurrentUserControllerClass {
	private static _instance: EditorCurrentUserControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorCurrentUserControllerClass());
	}

	private _username!: Ref<string | null>;
	private constructor() {}

	init() {
		this._username = ref(null);
	}

	username() {
		return this._username.value;
	}

	setUsername(username: string) {
		this._username.value = username;
	}
}

export const EditorCurrentUserController = EditorCurrentUserControllerClass.instance();
